/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3VIcon20Light = forwardRef('UiMenuDots3VIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.25 4.004a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z" }),
        React.createElement("path", { d: "M11.25 10a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z" }),
        React.createElement("path", { d: "M10 17.246a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" })));
});
